import { Injectable } from '@angular/core';

import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MapPanelService {

  isMapPanelVisibleSubject = new Subject<boolean>();
  forceDrawRouteSubject = new Subject<boolean>();
  mainMapZoomLevelOffsetChanged = new Subject<number>();

  constructor() { }
}
